import type { RootBlockModel } from '@blocksuite/affine/model';
import { BlockComponent } from '@blocksuite/affine/std';
import { html } from 'lit';

export class MindmapRootBlock extends BlockComponent<RootBlockModel> {
  override render() {
    return html`
      <style>
        .affine-mini-mindmap-root {
          display: block;
          width: 100%;
          height: 100%;

          background-size: 20px 20px;
          background-color: var(--streamlain-v2-layer-background-primary);
          background-image: radial-gradient(
            var(--streamlain-v2-edgeless-grid) 1px,
            var(--streamlain-v2-layer-background-primary) 1px
          );
        }
      </style>
      <div class="affine-mini-mindmap-root">
        ${this.host.renderChildren(this.model)}
      </div>
    `;
  }
}
